<template>
  <div class="container">
    <div class="box-cellphoneconfirmation">
      <h3 class="main-title">Confirmar celular</h3>
      <p class="title">Tu seguridad es lo más importante, por eso es fundamental que proporciones tu número celular, ya que algunas acciones que realices en la plataforma será necesaria la confirmación por SMS o llamada antes de completarse.</p>
      <div class="box-cellphone-configuration box-authy">
        <div class="container">
          <div class="row row-responsive">
            <div class="column column-sm-10 -centered-info">
              <img src="https://i.imgur.com/IYWaKYE.png" class="logo-authy">
            </div>
            <div class="column column-sm-90 -centered-info">
              <p>Recomendamos utilizar la app móvil de <a href="https://authy.com/" target="_blank">Authy</a> para realizar trasacciones en Cumplo. La respuesta es rápida y puedes descargarla:</p>
              <p><a href="https://itunes.apple.com/us/app/authy/id494168017" class="icon icon-ios" target="_blank">iOS</a> <a href="https://play.google.com/store/apps/details?id=com.authy.authy" class="icon icon-android" target="_blank">Android</a></p>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <form novalidate v-if="isSelectionScreen">
          <fieldset>
            <div class="row row-responsive">
              <div class="column column-xs-100 column-sm-40 column-offset-sm-10">
                <label for="cellphone">Tu número de celular guardado es:</label>
                <input type="text" name="cellphone" disabled v-model="cellPhoneNumber">
              </div>
              <div class="column column-xs-100 column-sm-40">
                <label for="cellphone" :class="{'error-text': endpointErrors.medium}">Comprobar número de celular:</label>
                <span class="select">
                  <select v-model.trim="$v.mediumSelection.cellPhoneVerification.$model" :class="{ 'error-label': $v.mediumSelection.cellPhoneVerification.$error }">
                    <option value="" disabled selected>Seleccione:</option>
                    <option value=1>Enviando un SMS</option>
                    <option value=2>Haciendo una llamada</option>
                  </select>
                  <span class="arrow"></span>
                </span>
                <p class="error" v-if="errors">
                  <span v-if="!$v.mediumSelection.cellPhoneVerification.required">Debe seleccionar un medio para comprobar su número de celular.</span>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="column">
                <button class="button float-right" :disabled="cellPhoneNumber === null" @click.prevent="submitMFA()">Enviar</button>
              </div>
            </div>
            </fieldset>
        </form>
        <form novalidate v-else>
          <fieldset>
            <div class="row row-responsive">
              <div class="column column-xs-100 column-sm-40 column-offset-sm-33">
                <label for="code" :class="{'error-text': endpointErrors.token}">Ingrese el código proporcionado:</label>
                <input type="text" name="code" placeholder="1234567" v-model.trim="$v.codeInteraction.verificationCode.$model">
                <p class="error" v-if="errors">
                  <span v-if="!$v.codeInteraction.verificationCode.required">El código es obligatorio.</span>
                  <span v-if="!$v.codeInteraction.verificationCode.numeric">El código debe ser numérico.</span>
                  <span v-if="!$v.codeInteraction.verificationCode.minLength">El código debe tener 7 números.</span>
                  <span v-if="!$v.codeInteraction.verificationCode.maxLength">El código debe tener 7 números.</span>
                </p>
                <p class="send-again">¿No recibiste el código? <a href="#" @click.prevent="sendMFAToServer()"><b>Enviar de nuevo</b></a> o seleccionar <a href="#" @click.prevent="changeMedium()"><b>método de validación</b></a></p>
              </div>
            </div>
            <div class="row codeok" v-if="statusCodeOK">
              <div class="column -vertical">
                <CheckmarkOK></CheckmarkOK>
                <p class="title">Tu celular ya ha sido validado.</p>
              </div>
            </div>
            <div class="row">
              <div class="column box-errors">
                <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
                </p>
                <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
                </p>
              </div>
            </div>
            <div class="row">
              <div class="column">
                <button class="button float-right" @click.prevent="submitToken()">Enviar</button>
                <button class="button float-right" v-if="statusCodeOK">Siguiente</button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>

</template>

<script>

import CheckmarkOK from '@/components/CheckmarkOK'

import { required, numeric, minLength, maxLength }
  from 'vuelidate/lib/validators'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'StepCellphoneConfirmation',
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  data () {
    return {
      errors: false,
      empty: false,
      isSelectionScreen: true,
      statusCodeError: false,
      statusCodeOK: false,
      cellPhoneNumber: null,
      endpointErrors: {
        medium: false,
        token: false
      },
      mediumSelection: {
        cellPhoneVerification: ''
      },
      codeInteraction: {
        verificationCode: null
      }
    }
  },
  validations: {
    mediumSelection: {
      cellPhoneVerification: { required }
    },
    codeInteraction: {
      verificationCode: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(7)
      }
    }
  },
  components: {
    CheckmarkOK
  },
  methods: {
    changeMedium: function () {
      this.isSelectionScreen = true
      this.verificationCode = null
      this.mediumSelection.cellPhoneVerification = ''
    },
    sendMFAToServer: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/mfa/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          medium: this.mediumSelection.cellPhoneVerification
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.isSelectionScreen = false
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.name = ('name' in response.data)
            break
          default:
            break
        }
      }
    },
    submitMFA: function () {
      this.empty = !this.$v.mediumSelection.$anyDirty
      this.errors = this.$v.mediumSelection.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendMFAToServer()
      }
    },
    sendTokenToServer: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/phone/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          token: this.codeInteraction.verificationCode
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.statusCodeError = true
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.name = ('name' in response.data)
            break
          default:
            break
        }
      }
    },
    submitToken: function () {
      this.empty = !this.$v.codeInteraction.$anyDirty
      this.errors = this.$v.codeInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendTokenToServer()
      }
    },
    getSavedPhone: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.cellPhoneNumber = response.data.phone
            break
          case 202:
            this.statusCodeError = true
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.name = ('name' in response.data)
            break
          default:
            break
        }
      }
    }
  },
  created: function () {
    this.getSavedPhone()
  }
}

</script>

<style lang="scss" scoped>

.box-cellphoneconfirmation {

  .title {
    font-size: 1.1em;
    font-style: italic;
    color: #666;
    line-height: 1.4;
  }
}

.box-cellphone-configuration {
  margin: 4rem 0;
  padding: 2rem 2rem 1rem;
  border: 1px solid #ccc;
  background-color: $white;
  border-radius: 6px;

  .logo-authy {
    width: 55px;
  }

  .icon {
    display: inline-block;
    width: 172px;
    height: 50px;
    text-indent: -9999px;

    &.icon-ios {
      background-image: url(https://i.imgur.com/16RuaCf.png);
    }
    &.icon-android {
      background-image: url(https://i.imgur.com/yDJRGov.png);
    }
  }
}

.send-again {
  font-size: 1.3rem;
}

.codeok {
  margin: 2rem 0;
  text-align: center;

  .-vertical {
    display: flex;
    /* alineacion vertical */
    align-items: center;
     /* alineacion horizontal */
    justify-content: center;
  }

  svg {
    display: inline;
    margin: 0;
  }

  .title {
    display: inline;
    margin-bottom: 0;
    margin-left: 10px;
  }
}

.codeerror {
  color: $red;
}

@media (max-width: 42rem) {
  .box-authy {

    .logo-authy {
      max-width: 30%;
    }

    .icon {
      margin-bottom: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepCellphoneConfirmation.vue